import moment from "moment";
import React from "react";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";
const salidaIcon = require("assets/img/icons/right-arrow-v2.png");

export const IngresosTable = ({
    ingresos = [],
    total_kg_secos_lab = 0,
    total_kg_secos_liq = 0,
    total_kg_humedos = 0,
    seleccionarIngreso,
}) => {
    // verificar si hay algún registro con DRC faltante (kg secos laboratorio o kg secos liquidación vacíos o cero)
    const hasDrcFaltante = ingresos.some(
        (item) => !item.kg_secos_lab || !item.kg_secos_liq,
    );

    return (
        <React.Fragment>
            {hasDrcFaltante && (
                <div className="d-flex align-items-center gap-10 mb-3">
                    <div className="ingresos-almacen__drc-faltante-indicador"></div>
                    <span>DRC faltante</span>
                </div>
            )}
            <div className="new-table-wrapper ingresos-almacen__table-wrapper">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>Ingreso ID</th>
                            <th>Fecha ingreso</th>
                            <th>Kg húmedos</th>
                            <th>Kg secos laboratorio</th>
                            <th>Kg secos liquidación</th>
                            {seleccionarIngreso && <th>Trasladar</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {ingresos.length === 0 && (
                            <tr>
                                <td
                                    colSpan={seleccionarIngreso ? 6 : 5}
                                    className="text-center"
                                >
                                    No hay ingresos disponibles.
                                </td>
                            </tr>
                        )}
                        {ingresos.map((item) => {
                            return (
                                <tr
                                    key={item.movimiento_id}
                                    className={
                                        !item.kg_secos_lab || !item.kg_secos_liq
                                            ? "ingresos-almacen__drc-faltante-row"
                                            : ""
                                    }
                                >
                                    <td className="text-center text-nowrap">
                                        {item.display_id}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.fecha_ingreso
                                            ? moment(item.fecha_ingreso).format(
                                                  "DD/MM/YYYY",
                                              )
                                            : "N/A"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_humedos}
                                            decimalScale={3}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.kg_secos_lab ? (
                                            <RenderKilogramo
                                                value={item.kg_secos_lab}
                                                decimalScale={3}
                                            />
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.kg_secos_liq ? (
                                            <RenderKilogramo
                                                value={item.kg_secos_liq}
                                                decimalScale={3}
                                            />
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                    {seleccionarIngreso && (
                                        <td className="text-center text-nowrap">
                                            <div className="table-actions">
                                                <img
                                                    src={salidaIcon}
                                                    alt="Trasladar recepción"
                                                    className="action_img"
                                                    title="Trasladar recepción"
                                                    onClick={() =>
                                                        seleccionarIngreso(item)
                                                    }
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                        <tr className="totales-row">
                            <td
                                colSpan={2}
                                className="text-right font-weight-bold"
                            >
                                Total:
                            </td>
                            <td className="text-center text-nowrap font-weight-bold">
                                <RenderKilogramo
                                    value={total_kg_humedos}
                                    decimalScale={3}
                                />
                            </td>
                            <td className="text-center text-nowrap font-weight-bold">
                                <RenderKilogramo
                                    value={total_kg_secos_lab}
                                    decimalScale={3}
                                />
                            </td>
                            <td className="text-center text-nowrap font-weight-bold">
                                <RenderKilogramo
                                    value={total_kg_secos_liq}
                                    decimalScale={3}
                                />
                            </td>
                            {seleccionarIngreso && <td></td>}
                        </tr>
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
